import { ClientDetails2 } from 'bff';
import { ToDoListEntry, ToDoListTab, StatusPillColour } from 'modules/dashboard/types';

export const formatToDoListData = (
  unsortedData: ClientDetails2[] | undefined
): {
  due: ToDoListEntry[];
  overdue: ToDoListEntry[];
  notCompliant: ToDoListEntry[];
} => {
  const formattedData = {
    [ToDoListTab.due]: [] as ToDoListEntry[],
    [ToDoListTab.overdue]: [] as ToDoListEntry[],
    [ToDoListTab.notCompliant]: [] as ToDoListEntry[]
  };
  let itemId = 1001;
  if (unsortedData) {
    for (const client of unsortedData) {
      for (const toDoItem of client.toDoItems) {
        let toDoItemTab: ToDoListTab | undefined = undefined;
        let status = '';
        let statusPillColour: StatusPillColour | undefined = undefined;

        const numOfDays = toDoItem.details.status.days;
        switch (toDoItem.details.status.label) {
          case 'NotCompliant':
            toDoItemTab = ToDoListTab.notCompliant;
            status = `Not compliant for ${numOfDays} ${numOfDays > 1 ? 'days' : 'day'}`;
            statusPillColour = StatusPillColour.red;
            break;
          case 'Late':
            toDoItemTab = ToDoListTab.overdue;
            status = `Late by ${numOfDays} ${numOfDays > 1 ? 'days' : 'day'}`;
            statusPillColour = StatusPillColour.red;
            break;
          case 'Due':
            toDoItemTab = ToDoListTab.due;
            status = `Due in ${numOfDays} ${numOfDays > 1 ? 'days' : 'day'}`;
            if (numOfDays <= 7) {
              statusPillColour = StatusPillColour.red;
            } else if (numOfDays <= 30) {
              statusPillColour = StatusPillColour.amber;
            } else if (numOfDays <= 60) {
              statusPillColour = StatusPillColour.blue;
            } else {
              statusPillColour = undefined;
            }
            break;
          default:
            toDoItemTab = undefined;
            break;
        }

        if (toDoItemTab === undefined || statusPillColour === undefined) {
          continue;
        }
        const entryItem: ToDoListEntry = {
          clientId: Number(client.clientID),
          toDoItemTab: toDoItemTab,
          toDoItemId: itemId++,
          clientName: `${client.clientFirstName} ${client.clientLastName}`,
          investmentNumber: toDoItem.investmentNumber,
          investmentName: toDoItem.investmentName,
          toDoItemTitle: toDoItem.details.title,
          toDoItemDueDate:
            toDoItem.details.dueReviewDate.toISOString().split('T')[0] ?? 'YYYY-MM-DD',
          toDoItemNumOfDays: numOfDays,
          toDoItemStatus: status,
          statusPillColour: statusPillColour
        };
        formattedData[entryItem.toDoItemTab].push(entryItem);
      }
    }
  }

  return {
    [ToDoListTab.due]: [...formattedData[ToDoListTab.due]].sort(
      (a, b) => a.toDoItemNumOfDays - b.toDoItemNumOfDays
    ),
    [ToDoListTab.overdue]: [...formattedData[ToDoListTab.overdue]].sort(
      (a, b) => b.toDoItemNumOfDays - a.toDoItemNumOfDays
    ),
    [ToDoListTab.notCompliant]: [...formattedData[ToDoListTab.notCompliant]].sort(
      (a, b) => b.toDoItemNumOfDays - a.toDoItemNumOfDays
    )
  };
};
